/* Porte Ta Broderie — scripts du thème (en-tête, couleurs, filtres de collection, fiche produit, panier).
   Aucune dépendance. Les textes viennent des fichiers de langue (JSON injecté dans la page). */
(function () {
  'use strict';
  var d = document, w = window;
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function on(el, ev, fn, opt) { if (el) el.addEventListener(ev, fn, opt); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f\u064b-\u065f\u0670]/g, '').replace(/\u0649/g, '\u064a').replace(/\u0629/g, '\u0647').replace(/[^a-z0-9\u0600-\u06ff]+/g, ' ').trim(); }

  /* ------------------------------------------------------------------ couleurs */
  var EXACT = {
    'black': '#111111', 'noir': '#111111', 'white': '#ffffff', 'blanc': '#ffffff', 'navy': '#1b2748', 'bleu marine': '#1b2748', 'navy blazer': '#1f293d',
    'royal': '#3155a6', 'bleu roi': '#3155a6', 'team royal': '#2a4aa0', 'heather grey': '#a7a7a7', 'gris chine': '#a7a7a7', 'baby pink': '#f4b6c2',
    'red': '#c62828', 'olive': '#6f7145', 'spruce': '#234b43', 'epicea': '#234b43', 'gold': '#d2a84a', 'gris fonce': '#45484a', 'dark grey': '#45484a',
    'kaki': '#a18f6b', 'khaki': '#a18f6b', 'pierre': '#b8ad98', 'stone': '#b8ad98', 'rose': '#e7a9b4', 'bleu clair': '#98c7df', 'canneberge': '#8f2942',
    'faded black': '#252525', 'faded coal': '#484846', 'faded indigo': '#4d5d71', 'faded grey': '#858580', 'faded bone': '#d8d0bc', 'faded khaki': '#91866c',
    'faded eucalyptus': '#728379', 'faded white': '#efece4', 'sport grey': '#b5b5b5', 'gris sport': '#b5b5b5', 'maroon': '#6d1f2a', 'irish green': '#169b62',
    'sky': '#8bc9e8', 'natural': '#e8dfc8', 'light pink': '#efbfd0', 'rose clair': '#efbfd0', 'light blue': '#9bcbe8', 'ash': '#d8d8d5',
    'vintage black': '#343434', 'noir vintage': '#343434', 'lavender': '#b8a7ce', 'lavande': '#b8a7ce', 'sky blue': '#90cbe8', 'bone': '#ded5c4',
    'team red': '#b52b36', 'team gold': '#c79c3b', 'carolina blue': '#7ba7d8', 'orange': '#ef7b2d', 'azalea': '#e76a9d', 'lime': '#a7c83b', 'daisy': '#f4cf35',
    'vert militaire': '#6f765f', 'military green': '#6f765f', 'tempete': '#77757a', 'storm': '#77757a', 'peche': '#f2b8a0', 'charcoal grey': '#4a4a4a',
    'charcoal heather': '#55575a', 'fresh green': '#bcd9c4', 'fresh pink': '#f0c9c6', 'natural stone': '#e0dcd0', 'violet': '#6b3fa0', 'bleu': '#2f6fd6', 'vert foret': '#1f4d3a'
  };
  /* Motifs arabes écrits sur le texte normalisé (alef nu, sans voyelles) : voir norm() */
  var FAMILIES = [
    ['marine', /(navy|marine|midnight|\u0643\u062d\u0644\u064a)/],
    ['gris', /(grey|gray|gris|\bash\b|heather|slate|silver|argent|charcoal|storm|tempete|anthracite|\u0631\u0645\u0627\u062f\u064a|\u0639\u0627\u0635\u0641|\u0645\u064a\u0644\u0627\u0646\u062c|\u0631\u064a\u0627\u0636\u064a)/],
    ['noir', /(black|noir|\bcoal\b|ebony|\u0627\u0633\u0648\u062f|\u0641\u062d\u0645)/],
    ['beige', /(bone|natural|naturel|stone|pierre|sand|sable|cream|creme|ecru|beige|oat|\u0628\u064a\u062c|\u0643\u0631\u064a\u0645\u064a|\u0631\u0645\u0644\u064a|\u0639\u0638\u0645\u064a|\u0637\u0628\u064a\u0639\u064a|\u062d\u062c\u0631\u064a)/],
    ['blanc', /(white|blanc|ivory|ivoire|\u0627\u0628\u064a\u0636)/],
    ['rose', /(pink|rose|azalea|peche|peach|fuchsia|blush|\u0648\u0631\u062f\u064a|\u0632\u0647\u0631\u064a|\u062e\u0648\u062e\u064a|\u0627\u0632\u0627\u0644\u064a\u0627)/],
    ['rouge', /(\bred\b|rouge|maroon|burgundy|bordeaux|cranberry|canneberge|cherry|garnet|\u0627\u062d\u0645\u0631|\u0639\u0646\u0627\u0628\u064a)/],
    ['orange', /(orange|rust|terracotta|\u0628\u0631\u062a\u0642\u0627\u0644\u064a)/],
    ['jaune', /(yellow|jaune|gold|dore|daisy|mustard|moutarde|\u0627\u0635\u0641\u0631|\u0630\u0647\u0628\u064a|\u062f\u0627\u064a\u0632\u064a)/],
    ['kaki', /(khaki|kaki|\u0643\u0627\u0643\u064a)/],
    ['vert', /(green|vert|olive|spruce|epicea|lime|eucalyptus|forest|foret|military|militaire|mint|menthe|sage|\u0627\u062e\u0636\u0631|\u0632\u064a\u062a\u0648\u0646\u064a|\u0639\u0633\u0643\u0631\u064a|\u0644\u064a\u0645\u0648\u0646\u064a|\u0627\u0648\u0643\u0627\u0644\u0628\u062a\u0648\u0633)/],
    ['violet', /(purple|violet|lavender|lavande|lilac|plum|mauve|\u0628\u0646\u0641\u0633\u062c\u064a|\u0627\u0631\u062c\u0648\u0627\u0646\u064a|\u0644\u0627\u0641\u0646\u062f\u0631)/],
    ['marron', /(brown|marron|chocolate|chocolat|coffee|camel|\u0628\u0646\u064a)/],
    ['bleu', /(blue|bleu|royal|\bsky\b|carolina|ciel|azur|indigo|\broi\b|\u0627\u0632\u0631\u0642|\u0633\u0645\u0627\u0648\u064a|\u0645\u0644\u0643\u064a|\u0646\u064a\u0644\u064a)/]
  ];
  var FAMHEX = { noir: '#1a1714', blanc: '#ffffff', gris: '#9a9a98', beige: '#d8cdb4', bleu: '#3f6fb5', marine: '#1b2748', rose: '#eebccb', rouge: '#a8242f', vert: '#4f7a4f', violet: '#8a6bb8', jaune: '#e0b43a', orange: '#ef7b2d', marron: '#6b4423', kaki: '#8f8a60' };
  function colorFamily(name) {
    var n = norm(name);
    if (!n) return 'gris';
    for (var i = 0; i < FAMILIES.length; i++) if (FAMILIES[i][1].test(n)) return FAMILIES[i][0];
    return 'gris';
  }
  function colorHex(name) { var n = norm(name); return EXACT[n] || FAMHEX[colorFamily(name)] || '#cfc7b8'; }
  function paintDots(root) {
    $$('[data-pb-color]', root).forEach(function (el) { el.style.setProperty('--swatch', colorHex(el.getAttribute('data-pb-color'))); });
    $$('.pdp__swatch', root).forEach(function (b) {
      var dot = b.querySelector('.pdp__swatch-dot');
      if (dot && !dot.style.getPropertyValue('--swatch')) dot.style.setProperty('--swatch', colorHex(b.value || b.getAttribute('data-gallery-color')));
    });
  }
  w.PBColor = { family: colorFamily, hex: colorHex, paint: paintDots };

  /* ------------------------------------------------------------------ en-tête */
  function initHeader() {
    var header = $('[data-pb-header]');
    var drawer = $('[data-pb-drawer]');
    var opener = $('[data-pb-drawer-open]');
    var lastFocus = null;

    function setSticky() {
      if (!header) return;
      d.documentElement.style.setProperty('--pb-sticky', header.offsetHeight + 'px');
    }
    setSticky();
    on(w, 'resize', setSticky);
    if (w.ResizeObserver && header) new ResizeObserver(setSticky).observe(header);

    function openDrawer() {
      if (!drawer) return;
      lastFocus = d.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      d.body.classList.add('pb-lock');
      if (opener) opener.setAttribute('aria-expanded', 'true');
      var f = $('.pb-drawer__top button, .pb-drawer a, .pb-drawer input', drawer);
      if (f) setTimeout(function () { f.focus(); }, 60);
    }
    function closeDrawer() {
      if (!drawer || !drawer.classList.contains('is-open')) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      d.body.classList.remove('pb-lock');
      if (opener) opener.setAttribute('aria-expanded', 'false');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    on(opener, 'click', openDrawer);
    $$('[data-pb-drawer-close]').forEach(function (b) { on(b, 'click', closeDrawer); });
    on(drawer, 'keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = $$('a[href],button:not([disabled]),input,select', drawer).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    $$('[data-pb-dtoggle]').forEach(function (btn) {
      on(btn, 'click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        var sub = d.getElementById(btn.getAttribute('aria-controls'));
        if (sub) sub.classList.toggle('is-open', !open);
      });
    });

    /* recherche mobile */
    var st = $('[data-pb-search-toggle]'), ms = $('[data-pb-msearch]');
    on(st, 'click', function () {
      var open = ms.classList.toggle('is-open');
      st.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) { var i = $('input', ms); if (i) i.focus(); }
    });

    /* menus déroulants accessibles (survol + clavier) */
    $$('[data-pb-nav-item].has-menu').forEach(function (li) {
      var trig = $('[data-pb-nav-trigger]', li), t;
      function setOpen(v) { li.classList.toggle('is-open', v); if (trig) trig.setAttribute('aria-expanded', v ? 'true' : 'false'); }
      on(li, 'mouseenter', function () { clearTimeout(t); setOpen(true); });
      on(li, 'mouseleave', function () { t = setTimeout(function () { setOpen(false); }, 120); });
      on(li, 'focusin', function () { setOpen(true); });
      on(li, 'focusout', function (e) { if (!li.contains(e.relatedTarget)) setOpen(false); });
    });
    on(d, 'keydown', function (e) {
      if (e.key !== 'Escape') return;
      closeDrawer();
      $$('[data-pb-nav-item].is-open').forEach(function (li) { li.classList.remove('is-open'); var tr = $('[data-pb-nav-trigger]', li); if (tr) tr.setAttribute('aria-expanded', 'false'); });
    });
    on(w, 'resize', function () { if (w.innerWidth >= 1024) closeDrawer(); });
  }

  /* ------------------------------------------------------------------ sélecteur de langue (<details> + boutons du formulaire « localization »)
     Sans JavaScript la liste s'ouvre et se ferme avec <details> ; ici on ajoute : fermeture au clic extérieur, à Échap et quand le focus part,
     ouverture à la flèche du bas, navigation aux flèches, un seul menu ouvert à la fois. */
  function initLang() {
    var dds = $$('details[data-pb-lang]');
    if (!dds.length) return;
    function opts(dd) { return $$('button[name="locale_code"]', dd); }
    dds.forEach(function (dd) {
      var sum = $('summary', dd);
      on(dd, 'toggle', function () {
        if (!dd.open) return;
        dds.forEach(function (o) { if (o !== dd && o.open) o.open = false; });
      });
      on(dd, 'keydown', function (e) {
        var k = e.key;
        if (k === 'Escape' && dd.open) { dd.open = false; if (sum) sum.focus(); e.stopPropagation(); return; }
        if (k !== 'ArrowDown' && k !== 'ArrowUp') return;
        var list = opts(dd); if (!list.length) return;
        e.preventDefault();
        if (!dd.open) { dd.open = true; }
        var i = list.indexOf(d.activeElement);
        if (i < 0) i = k === 'ArrowDown' ? -1 : 0;
        i = k === 'ArrowDown' ? (i + 1) % list.length : (i - 1 + list.length) % list.length;
        list[i].focus();
      });
      on(dd, 'focusout', function (e) { if (dd.open && e.relatedTarget && !dd.contains(e.relatedTarget)) dd.open = false; });
    });
    on(d, 'click', function (e) { dds.forEach(function (dd) { if (dd.open && !dd.contains(e.target)) dd.open = false; }); });
    /* ouvrir le tiroir mobile ou une recherche referme aussi la liste */
    on(d, 'scroll', function () { dds.forEach(function (dd) { if (dd.open) dd.open = false; }); }, { passive: true });
  }

  /* ------------------------------------------------------------------ collection : filtres, tri, chargement progressif */
  var SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL', 'ONE'];
  function normSize(s) {
    var v = String(s || '').trim().toUpperCase().replace(/\s+/g, '');
    if (v === 'XXL') v = '2XL';
    if (v === 'XXXL') v = '3XL';
    if (/^(ONESIZE|UNIQUE|TAILLEUNIQUE|ONE)$/.test(v) || /موحد|واحد/.test(v)) v = 'ONE';
    return v;
  }
  function slug(s) { return norm(s).replace(/\s+/g, '-'); }

  function initCollection() {
    var root = $('[data-pb-collection]');
    var grid = root && $('[data-pb-grid]', root);
    if (!root || !grid) return;
    var T = {};
    try { T = JSON.parse($('[data-pb-i18n]').textContent); } catch (e) { return; }
    (function dec(o) { var ta = d.createElement('textarea'); Object.keys(o).forEach(function (k) { var v = o[k]; if (typeof v === 'string') { ta.innerHTML = v; o[k] = ta.value; } else if (v && typeof v === 'object') dec(v); }); })(T);
    var items = $$(':scope > li', grid).map(function (li, i) {
      var c = $('[data-pb-card]', li), ds = c.dataset;
      var sizes = (ds.sizes || '').split('|').filter(Boolean).map(normSize);
      var colors = {}; (ds.colors || '').split('|').filter(Boolean).forEach(function (n) { colors[colorFamily(n)] = 1; });
      var uni = (ds.universe || '').split('|').filter(Boolean);
      return { el: li, i: i, type: ds.type || '', price: parseInt(ds.price, 10) || 0, avail: ds.avail === '1', created: parseInt(ds.created, 10) || 0, sizes: sizes, colors: Object.keys(colors), promo: !!ds.promo, universe: uni };
    });
    if (!items.length) return;
    /* types d'article : « T-SHIRT » (produit créé par l'imprimeur) et « T-shirt » ne forment qu'une seule valeur de filtre */
    (function () {
      var known = ['T-shirt', 'Polo', 'Sweat à capuche', 'Sweat', 'Crop hoodie', 'Casquette', 'Bonnet', 'Sac', 'Accessoire'], canon = {};
      known.forEach(function (k) { canon[k.toLowerCase()] = k; });
      items.forEach(function (it) { var k = it.type.toLowerCase(); if (!canon[k] && it.type) canon[k] = it.type; it.type = canon[k] || it.type; });
    })();

    var cur = (w.Shopify && w.Shopify.currency && w.Shopify.currency.active) || 'EUR';
    function money(v) { try { return new Intl.NumberFormat(d.documentElement.lang || 'fr', { style: 'currency', currency: cur, maximumFractionDigits: 0 }).format(v); } catch (e) { return v + ' ' + cur; } }
    var B = [{ k: 'b1', lo: 0, hi: 3000 }, { k: 'b2', lo: 3000, hi: 5000 }, { k: 'b3', lo: 5000, hi: 8000 }, { k: 'b4', lo: 8000, hi: 1e9 }];
    function bucketLabel(b) { return String(T[b.k] || '').replace('__A__', money(b.lo / 100)).replace('__B__', money(b.hi / 100)); }

    var PAGE = 24;
    var state = { type: [], size: [], color: [], price: [], avail: [], promo: [], universe: [], sort: 'relevance' };
    var shown = PAGE;

    function readUrl() {
      var q = new URLSearchParams(w.location.search);
      Object.keys(state).forEach(function (k) {
        if (k === 'sort') { var s = q.get('s'); if (s && /^(relevance|new|price-asc|price-desc)$/.test(s)) state.sort = s; return; }
        var v = q.get(k); state[k] = v ? v.split(',').filter(Boolean) : [];
      });
    }
    function writeUrl() {
      var q = new URLSearchParams(w.location.search);
      Object.keys(state).forEach(function (k) {
        if (k === 'sort') { if (state.sort !== 'relevance') q.set('s', state.sort); else q.delete('s'); return; }
        if (state[k].length) q.set(k, state[k].join(',')); else q.delete(k);
      });
      var qs = q.toString();
      try { w.history.replaceState(null, '', w.location.pathname + (qs ? '?' + qs : '')); } catch (e) {}
    }

    /* facettes : valeurs présentes dans la collection */
    function distinct(fn) { var m = {}, out = []; items.forEach(function (it) { fn(it).forEach(function (v) { if (v && !m[v]) { m[v] = 1; out.push(v); } }); }); return out; }
    var F = {
      type: { label: T.type, values: distinct(function (it) { return [it.type]; }).sort(function (a, b) { var o = ['T-shirt', 'Polo', 'Sweat à capuche', 'Sweat', 'Crop hoodie', 'Casquette', 'Bonnet', 'Sac', 'Accessoire'], x = o.indexOf(a), y = o.indexOf(b); return (x < 0 ? 99 : x) - (y < 0 ? 99 : y); }), get: function (it) { return [it.type]; }, name: function (v) { return T.types[slug(v)] || v; } },
      size: { label: T.size, values: distinct(function (it) { return it.sizes; }).sort(function (a, b) { var x = SIZE_ORDER.indexOf(a), y = SIZE_ORDER.indexOf(b); return (x < 0 ? 99 : x) - (y < 0 ? 99 : y); }), get: function (it) { return it.sizes; }, name: function (v) { return v === 'ONE' ? T.one_size : v; } },
      color: { label: T.color, values: distinct(function (it) { return it.colors; }), get: function (it) { return it.colors; }, name: function (v) { return T.colors[v] || v; } },
      price: { label: T.price, values: B.map(function (b) { return b.k; }), get: function (it) { return B.filter(function (b) { return it.price >= b.lo && it.price < b.hi; }).map(function (b) { return b.k; }); }, name: function (v) { return bucketLabel(B.filter(function (b) { return b.k === v; })[0]); } },
      avail: { label: T.avail, values: items.some(function (it) { return !it.avail; }) ? ['1'] : [], get: function (it) { return it.avail ? ['1'] : []; }, name: function () { return T.in_stock; } },
      promo: { label: T.promo, values: items.some(function (it) { return it.promo; }) ? ['1'] : [], get: function (it) { return it.promo ? ['1'] : []; }, name: function () { return T.promo_only; } },
      /* pays : tous ceux présents dans la collection, dans l'ordre de la boutique (Algérie, Maroc, Tunisie, France, Égypte, Turquie, Sénégal, RDC, puis Berbère) */
      universe: { label: T.universe, values: distinct(function (it) { return it.universe; }).sort(function (a, b) { var o = Object.keys(T.universes || {}), x = o.indexOf(a), y = o.indexOf(b); return (x < 0 ? 99 : x) - (y < 0 ? 99 : y); }), get: function (it) { return it.universe; }, name: function (v) { return T.universes[v] || v; } }
    };
    var ORDER = ['universe', 'type', 'size', 'color', 'price', 'avail', 'promo'];
    ORDER = ORDER.filter(function (k) { var n = F[k].values.length; return k === 'avail' || k === 'promo' ? n > 0 : n > 1; });
    /* nettoyage de l'état : valeurs inconnues ignorées */
    Object.keys(F).forEach(function (k) { state[k] = state[k].filter(function (v) { return F[k].values.indexOf(v) >= 0; }); });

    function matches(it, skip) {
      for (var i = 0; i < ORDER.length; i++) {
        var k = ORDER[i]; if (k === skip || !state[k].length) continue;
        var vals = F[k].get(it);
        if (!state[k].some(function (v) { return vals.indexOf(v) >= 0; })) return false;
      }
      return true;
    }
    function count(k, v) { var n = 0; items.forEach(function (it) { if (matches(it, k) && F[k].get(it).indexOf(v) >= 0) n++; }); return n; }

    var desktop = $('[data-pb-filters]', root), mobBody = $('[data-pb-fbody]', d), fdrawer = $('[data-pb-fdrawer]', d);
    function facetHtml(k, pfx) {
      var f = F[k], h = '<details class="pb-fgroup"' + (ORDER.indexOf(k) < 5 ? ' open' : '') + '><summary>' + esc(f.label) + '</summary><div class="pb-fgroup__body">';
      if (k === 'size') h += '<div class="pb-fsizes">';
      f.values.forEach(function (v) {
        var n = count(k, v), on_ = state[k].indexOf(v) >= 0, id = pfx + k + '-' + slug(v);
        var dis = n === 0 && !on_;
        if (k === 'size') h += '<label class="pb-fchip' + (dis ? ' is-empty' : '') + '"><input type="checkbox" data-k="' + k + '" data-v="' + esc(v) + '" id="' + id + '"' + (on_ ? ' checked' : '') + (dis ? ' disabled' : '') + '><span>' + esc(f.name(v)) + '</span></label>';
        else h += '<label class="pb-fopt' + (dis ? ' is-empty' : '') + '"><input type="checkbox" data-k="' + k + '" data-v="' + esc(v) + '" id="' + id + '"' + (on_ ? ' checked' : '') + (dis ? ' disabled' : '') + '>' + (k === 'color' ? '<i class="pb-dot" style="--swatch:' + FAMHEX[v] + '"></i>' : '') + '<span>' + esc(f.name(v)) + '</span><span class="pb-fopt__n">' + n + '</span></label>';
      });
      if (k === 'size') h += '</div>';
      return h + '</div></details>';
    }
    function renderFacets() {
      var openState = {};
      [desktop, mobBody].forEach(function (c) { if (c) $$('details.pb-fgroup', c).forEach(function (dt) { var s = $('summary', dt); if (s) openState[s.textContent] = dt.open; }); });
      ['d-', 'm-'].forEach(function (pfx, idx) {
        var c = idx ? mobBody : desktop; if (!c) return;
        c.innerHTML = ORDER.map(function (k) { return facetHtml(k, pfx); }).join('');
        $$('details.pb-fgroup', c).forEach(function (dt) { var s = $('summary', dt); if (s && s.textContent in openState) dt.open = openState[s.textContent]; });
      });
    }

    var cnt = $('[data-pb-count]', root), active = $('[data-pb-active]', root), empty = $('[data-pb-empty]', root), more = $('[data-pb-more]', root), shownEl = $('[data-pb-shown]', root), bar = $('[data-pb-bar]', root);
    var fbtn = $('[data-pb-fopen]', root), fbadge = $('[data-pb-fbadge]', root), fshow = $('[data-pb-fshow]', d), sortSel = $('[data-pb-sort]', root);

    function fmt(tpl, n) { return String(tpl).replace('__N__', n); }
    function sorted(list) {
      var a = list.slice();
      if (state.sort === 'new') a.sort(function (x, y) { return y.created - x.created || x.i - y.i; });
      else if (state.sort === 'price-asc') a.sort(function (x, y) { return x.price - y.price || x.i - y.i; });
      else if (state.sort === 'price-desc') a.sort(function (x, y) { return y.price - x.price || x.i - y.i; });
      else a.sort(function (x, y) { return x.i - y.i; });
      return a;
    }
    function activeCount() { return ORDER.reduce(function (n, k) { return n + state[k].length; }, 0); }

    function apply(resetShown) {
      if (resetShown) shown = PAGE;
      var list = sorted(items.filter(function (it) { return matches(it); }));
      var frag = d.createDocumentFragment();
      items.forEach(function (it) { it.el.hidden = true; });
      list.forEach(function (it, idx) { frag.appendChild(it.el); it.el.hidden = idx >= shown; });
      /* les éléments non retenus restent à la fin, masqués */
      items.forEach(function (it) { if (list.indexOf(it) < 0) frag.appendChild(it.el); });
      grid.appendChild(frag);
      var n = list.length;
      if (cnt) cnt.textContent = fmt(n === 1 ? T.count_one : T.count_other, n);
      if (empty) empty.hidden = n > 0;
      grid.hidden = n === 0;
      if (more) {
        var vis = Math.min(shown, n);
        more.hidden = n <= PAGE || vis >= n;
        if (shownEl) shownEl.textContent = String(T.shown).replace('__S__', vis).replace('__N__', n);
        if (bar) bar.style.width = (n ? Math.round(vis / n * 100) : 0) + '%';
      }
      /* pastilles actives */
      if (active) {
        var h = '';
        ORDER.forEach(function (k) { state[k].forEach(function (v) { h += '<button type="button" class="pb-fchip-x" data-k="' + k + '" data-v="' + esc(v) + '" aria-label="' + esc(T.remove) + ' : ' + esc(F[k].name(v)) + '">' + esc(F[k].name(v)) + '</button>'; }); });
        if (h) h += '<button type="button" class="pb-fclear" data-pb-reset>' + esc(T.clear_all) + '</button>';
        active.innerHTML = h;
      }
      var ac = activeCount();
      if (fbadge) { fbadge.textContent = ac; fbadge.hidden = ac === 0; }
      if (fshow) fshow.textContent = fmt(n === 1 ? T.show_one : T.show_other, n);
      if (sortSel) sortSel.value = state.sort;
      renderFacets();
      writeUrl();
    }

    var focusId = null;
    function toggle(k, v, checked) {
      var a = state[k], i = a.indexOf(v);
      if (checked && i < 0) a.push(v); else if (!checked && i >= 0) a.splice(i, 1);
      apply(true);
      if (focusId) { var el = d.getElementById(focusId); if (el && !el.disabled) el.focus(); focusId = null; }
    }
    function reset() { ORDER.forEach(function (k) { state[k] = []; }); apply(true); }
    function delegate(container) {
      on(container, 'change', function (e) { var t = e.target; if (t.matches('input[data-k]')) { focusId = t.id; toggle(t.getAttribute('data-k'), t.getAttribute('data-v'), t.checked); } });
      on(container, 'click', function (e) {
        var x = e.target.closest('.pb-fchip-x'); if (x) toggle(x.getAttribute('data-k'), x.getAttribute('data-v'), false);
        if (e.target.closest('[data-pb-reset]')) reset();
      });
    }
    delegate(mobBody); delegate(root);
    on(fdrawer, 'click', function (e) { if (e.target.closest('[data-pb-reset]')) reset(); });
    on(sortSel, 'change', function () { state.sort = sortSel.value; apply(true); });
    on($('[data-pb-loadmore]', root), 'click', function () {
      var before = shown; shown += PAGE; apply(false);
      var first = items.filter(function (it) { return !it.el.hidden; })[before];
      if (first) { var a = $('a', first.el); if (a) a.focus({ preventScroll: true }); }
    });

    /* tiroir de filtres (mobile) */
    var lastF = null;
    function openF() { if (!fdrawer) return; lastF = d.activeElement; fdrawer.classList.add('is-open'); fdrawer.setAttribute('aria-hidden', 'false'); d.body.classList.add('pb-lock'); var c = $('button', fdrawer); if (c) c.focus(); }
    function closeF() { if (!fdrawer) return; fdrawer.classList.remove('is-open'); fdrawer.setAttribute('aria-hidden', 'true'); d.body.classList.remove('pb-lock'); if (lastF && lastF.focus) lastF.focus(); }
    on(fbtn, 'click', openF);
    $$('[data-pb-fclose]', d).forEach(function (b) { on(b, 'click', closeF); });
    on(d, 'keydown', function (e) { if (e.key === 'Escape') closeF(); });
    if (fbtn) fbtn.hidden = false;

    readUrl();
    Object.keys(F).forEach(function (k) { state[k] = state[k].filter(function (v) { return F[k].values.indexOf(v) >= 0; }); });
    if (activeCount() > PAGE) shown = 1e6;
    apply(false);
    paintDots(grid);
  }

  /* ------------------------------------------------------------------ fiche produit */
  function initProduct() {
    var root = $('[data-ptb-product-root]');
    if (!root) return;
    paintDots(root);
    $$('[data-pb-guide]', root).forEach(function (b) {
      on(b, 'click', function (e) {
        e.preventDefault();
        var det = $('#pb-desc', d), tbl = det && $('table', det);
        if (!det) return;
        det.open = true;
        var target = tbl || det;
        setTimeout(function () { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 60);
      });
    });
    /* le visuel des couleurs apparaît avec l'état « sélectionné » posé par ptb-product : on repeint après chaque clic */
    on(root, 'click', function () { setTimeout(function () { paintDots(root); }, 0); });
  }

  /* ------------------------------------------------------------------ panier */
  function initCart() {
    var form = $('[data-pb-cart-form]');
    if (!form) return;
    var only = form.getAttribute('data-pb-only-marker') === '1';
    if (only) {
      fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } }).then(function () { w.location.reload(); }).catch(function () {});
      return;
    }
    var upd = $('[name=update]', form), timer;
    function submitSoon() { clearTimeout(timer); timer = setTimeout(function () { if (form.requestSubmit && upd) form.requestSubmit(upd); else if (upd) upd.click(); }, 650); }
    $$('.pb-qty', form).forEach(function (q) {
      var input = $('input', q), min = parseInt(input.min, 10) || 0, max = parseInt(input.max, 10) || 99;
      on(q, 'click', function (e) {
        var b = e.target.closest('button[data-d]'); if (!b) return;
        var v = (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-d'), 10);
        input.value = Math.max(min, Math.min(max, v)); submitSoon();
      });
      on(input, 'change', submitSoon);
    });
    if (upd) upd.hidden = true;
  }

  function ready(fn) { if (d.readyState !== 'loading') fn(); else d.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    initHeader(); initLang(); paintDots(d); initCollection(); initProduct(); initCart();
    on(d, 'ptb:favoris', function () { paintDots(d); });
  });
})();
